const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/Footer/Links.tsx';
import * as React from 'react';
import { ReactNode, useMemo } from 'react';
import { Link as MUILink } from '@mui/material';
import { css } from '@emotion/css';
import { TextInput, useText } from '@cistec/common_web/utils/intlUtils';
import { HttpPrefix } from 'App/defs/setupDefs';
import { useTheme } from '@mui/material/styles';

const useLinkClassName = () => {
    const theme = useTheme();
    return useMemo(
        () => css`
            display: inline-block;
            padding: ${theme.spacing(2)};
            font-size: 14px;
            text-decoration: none;
            @media (max-width: ${theme?.breakpoints?.values?.sm}px) {
                padding: ${theme.spacing(1)};
            }
        `,
        [theme]
    );
};

interface LinkProps {
    text: TextInput;
    href: HttpPrefix;
}

export const Link = (props: LinkProps) => {
    const text = useText(props.text);
    const linkClassName = useLinkClassName();

    return (
        <MUILink href={props.href} target="_blank" rel="noopener" variant="body2" className={linkClassName}>
            {text}
        </MUILink>
    );
};

interface Props {
    children: ReactNode;
}

export const Links = (props: Props) => {
    return <>{props.children}</>;
};
